import React from 'react'
import {
    Flex,
    useMultiStyleConfig,
    Text,
    Box,
    useStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {FormattedNumber} from 'react-intl'
import ProductTileImage from '../../../components/product-tile/partials/product-tile-image'
//import useProductData from '../../../hooks/use-product-data'
//import {PRODUCT_CUSTOM_SELECTABLE_ATTRIBUTE_ID} from '../../../constants'
import UnitPrice from './unit-price'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import ItemVariantProvider from '@salesforce/retail-react-app/app/components/item-variant'

const FreeItemPromoTile = ({product, actionButton, isGrey = false}) => {
    const styles = useMultiStyleConfig('FreeItemPromo')
    const productStyles = useStyleConfig('ProductItem')
    const {promoTile} = styles || {}
    //const selectableAttributeId = PRODUCT_CUSTOM_SELECTABLE_ATTRIBUTE_ID
    //const {productUrl} = useProductData(product, selectableAttributeId)
    const {currency: activeCurrency} = useCurrency()

    return (
        <Flex {...promoTile?.container} opacity={isGrey ? '0.5' : 'unset'}>
            <ItemVariantProvider variant={product}>
                {/* Image */}
                <Flex {...promoTile?.imageContainer}>
                    <ProductTileImage
                        product={product}
                        // productUrl={productUrl}
                        variant="freeItemPromo"
                        isInformativeLabelActive={false}
                    />
                </Flex>

                {/* Info + Action */}
                <Flex {...promoTile?.subContainer}>
                    <Flex {...promoTile?.infoContainer}>
                        <Text isTruncated {...promoTile?.productName}>
                            {product?.c_variantIdentifier || product?.name || product?.productName}
                        </Text>
                        <Flex
                            flexDir="row"
                            justifyContent="center"
                            alignItems="center"
                            gap="xsmall.base"
                        >
                            <FormattedNumber style="currency" currency={activeCurrency} value={0} />
                            <Box
                                display="flex"
                                flexDir="row"
                                justifyContent="center"
                                alignItems="center"
                                gap="xsmall.base"
                            >
                                <Box {...productStyles?.suggestedPrice}>
                                    <UnitPrice
                                        currency={activeCurrency}
                                        hasStrikethrough={true}
                                        isFreeItemPromo={true}
                                    />
                                </Box>
                                {/* <Text {...productStyles?.suggestedText} color="success.100">
                                    {intl.formatMessage({
                                        id: 'item_variant.suggested_price',
                                        defaultMessage: 'Suggested Price',
                                    })}
                                </Text> */}
                            </Box>
                        </Flex>
                    </Flex>

                    <Flex flexShrink="0" alignItems="center">
                        {actionButton}
                    </Flex>
                </Flex>
            </ItemVariantProvider>
        </Flex>
    )
}

export default FreeItemPromoTile

FreeItemPromoTile.propTypes = {
    product: PropTypes.object,
    useRadio: PropTypes.bool,
    actionButton: PropTypes.object,
    isGrey: PropTypes.bool,
}
